import React, { useState } from "react";
import { Row, Button, Spinner } from "react-bootstrap";
import styles from "./signup.module.css";
import SignInInput from "../../common/SigninInput/signinInput";
import PasswordHide from "./assets/PasswordHide.svg";
import PasswordShow from "./assets/PasswordShow.svg";
import usericon from "./assets/User.svg";
import passwordicon from "./assets/Password.svg";
import { useMyContext } from "../../myContext";
import CommonButton from "../CommonButton/CommonButton";

const CreateAccount = ({
  username,
  password,
  handleChange,
  setStepToShow,
  confirmPassword,
  passwordValidation,
  createNewAccount,
  confirmPasswordError,
  passwordInvalid,
  confirmPasswordInvalid,
  loading,
  showError,
  Title,
  Subtitle,
  ButtonTitle,
}) => {
  const nextStep = () => {
    setStepToShow("emailOtp");
  };

  const [passwordType, setPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const {themeColor} = useMyContext('');

  const togglePasswordVisibility = () => {
    const type = passwordType === "password" ? "text" : "password";
    setPasswordType(type);
  };

  const toggleConfirmPasswordVisibility = () => {
    const type = confirmPasswordType === "password" ? "text" : "password";
    setConfirmPasswordType(type);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (!passwordValidation()) {
        createNewAccount();
      }}
  }

  return (
    <>
      <Row className={styles.title}>{Title}</Row>
      <div className={styles.subsmalltitle}>{Subtitle}</div>

      <Row className="ml-0 mr-0 mt-4">
        <SignInInput
          label="Email ID"
          type="text"
          name="email"
          value={username}
          containerClasses={styles.passwordInvalid}
          disabled={true}
          icon={usericon}
        />
      </Row>
      <Row className="ml-0 mr-0 mt-2" style={{ position: "relative" }}>
        <SignInInput
          label="Password"
          placeholder="Enter Password"
          name="password"
          type={passwordType}
          value={password}
          containerClasses={styles.passwordInvalid}
          onChange={(event) => {
            // setPassword(password)
            handleChange(event);
          }}
          onPaste={(e) => {
            e.preventDefault();
            return false;
          }}
          onCopy={(e) => {
            e.preventDefault();
            return false;
          }}
          errorMessage={confirmPasswordError}
          isInvalid={passwordInvalid}
          icon={passwordicon}
        />
        {
          <img
            style={{ height: "43px", width: "43px" }}
            alt=""
            className={styles.toggle}
            src={passwordType === "password" ? PasswordHide : PasswordShow}
            onClick={togglePasswordVisibility}
          />
        }
      </Row>
      <Row className="ml-0 mr-0 mt-2" style={{ position: "relative" }}>
        <SignInInput
          label="Confirm Password"
          placeholder="Enter Password"
          name="confirm_password"
          type={confirmPasswordType}
          value={confirmPassword}
          containerClasses={styles.passwordInvalid}
          onChange={(event) => {
            handleChange(event);
          }}
          onPaste={(e) => {
            e.preventDefault();
            return false;
          }}
          onCopy={(e) => {
            e.preventDefault();
            return false;
          }}
          errorMessage={confirmPasswordError}
          isInvalid={confirmPasswordInvalid}
          icon={passwordicon}
          onKeyPress={handleKeyPress}
        />
        {
          <img
            style={{ height: "43px", width: "43px" }}
            alt=""
            className={styles.toggle}
            src={
              confirmPasswordType === "password" ? PasswordHide : PasswordShow
            }
            onClick={toggleConfirmPasswordVisibility}
          />
        }
      </Row>
      <Row className={`${styles.buttonPad} mt-4`}>
        {showError !== "" ? (
          <div className={styles.errorState}>{showError}</div>
        ) : (
          ""
        )}
        <CommonButton
          title={ButtonTitle}
          onClick={() => {
            if (!passwordValidation()) {
              createNewAccount();
            }
          }}
          loading={loading}
          disabled={loading}
          padding={"10px 20px"}
        />
        {/* <Button
          className={`${styles.button} themeButton`}
          onClick={() => {
            if (!passwordValidation()) {
              createNewAccount();
            }
          }}
          disabled={loading}
          style={{background: themeColor, border: "0px"}}
        >
          {loading && (
            <Spinner animation="border" className={styles.spinnerColor} style={{borderColor: themeColor, borderRightColor: "white"}}/>
          )}
          {ButtonTitle}
        </Button> */}
      </Row>
    </>
  );
};

export default CreateAccount;
